module.exports = __webpack_public_path__ + "static/img/安盛天平@2x.0f253f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/安盛天平@2x.png
// module id = PI2g
// module chunks = 0